import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../css/navbar.css";
import { FaChevronDown } from "react-icons/fa";
import { FiDownload, FiLock, FiEye, FiEyeOff } from "react-icons/fi";
import { MdLogout } from "react-icons/md";
import { toast } from "react-toastify";
import "../css/modal.css";

const Navbar = ({ toggleSidebar }) => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [userName, setUserName] = useState("Admin");
  const [userEmail, setUserEmail] = useState("");
  const location = useLocation();
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const Api = process.env.REACT_APP_BACKEND_URL;

  const resetChangePasswordForm = () => {
    setShowChangePasswordModal(false);
    setNewPassword("");
    setOldPassword("");
    setConfirmPassword("");
    setShowOldPassword(false);
    setShowNewPassword(false);
    setShowConfirmPassword(false);
  };

  useEffect(() => {
    const storedName = localStorage.getItem("first_name");
    const storedEmail = localStorage.getItem("email");
    setUserName(storedName || "Admin");
    setUserEmail(storedEmail || "");
  }, []);

  const handleDownloadReport = async () => {
    try {
      setIsDownloading(true);
      const token = localStorage.getItem("access_token");

      // Determine report type based on current path
      let reportType = "dashboard";
      if (location.pathname === "/users-management") reportType = "users";
      else if (location.pathname === "/content-management") reportType = "content";
      else if (location.pathname === "/revenue-per-creator") reportType = "revenue";

      const response = await fetch(`${Api}admin/report/pdf?type=${reportType}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to generate report");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Fanatech_${reportType}_Report_${new Date().toISOString().split('T')[0]}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      toast.success(`${reportType.charAt(0).toUpperCase() + reportType.slice(1)} report downloaded successfully`);
    } catch (error) {
      console.error("Download Error:", error);
      toast.error("Failed to download report");
    } finally {
      setIsDownloading(false);
    }
  };

  const getPageTitle = (pathname) => {
    switch (pathname) {
      case "/dashboard":
        return "Dashboard";
      case "/users-management":
        return "User Management";
      case "/content-management":
        return "Content Management";
      case "/revenue-per-creator":
        return "Creator Performance";
      case "/reports":
        return "Reports";
      default:
        return "Dashboard";
    }
  };


  const handleLogoutClick = () => {
    setIsProfileOpen(false);
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("id");
    localStorage.removeItem("first_name");
    localStorage.removeItem("role");
    setShowLogoutModal(false);
    navigate("/");
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
    if (newPassword.length < 8) {
      toast.error("Password must be at least 8 characters");
      return;
    }


    try {
      setIsChangingPassword(true);
      const token = localStorage.getItem("access_token");
      const formData = new FormData();
      formData.append("old_password", oldPassword);
      formData.append("new_password", newPassword);
      formData.append("confirm_password", confirmPassword);

      const response = await fetch(`${Api}admin/change-password`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.detail || "Failed to change password");
      }

      toast.success("Password updated successfully");
      resetChangePasswordForm();
    } catch (error) {
      console.error("Change Password Error:", error);
      toast.error(error.message || "Internal Server Error");
    } finally {
      setIsChangingPassword(false);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <header className="navbar">
        <div
          className="navbar-left"
          style={{ display: "flex", alignItems: "center", gap: "15px" }}
        >
          <button
            className="mobile-menu-btn"
            onClick={toggleSidebar}
            aria-label="Toggle Sidebar"
          >
            ☰
          </button>
          <h1 className="page-title">{getPageTitle(location.pathname)}</h1>
        </div>
        <div className="navbar-right" style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          {/* <button
            className="download-report-btn"
            onClick={handleDownloadReport}
            disabled={isDownloading}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "8px 16px",
              borderRadius: "10px",
              border: "1px solid #e2e8f0",
              background: "white",
              color: "#1a1a1a",
              fontSize: "0.85rem",
              fontWeight: "600",
              cursor: isDownloading ? "not-allowed" : "pointer",
              transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
            }}
            onMouseOver={(e) => {
              if (!isDownloading) {
                e.currentTarget.style.borderColor = "#ff2d2d";
                e.currentTarget.style.color = "#ff2d2d";
                e.currentTarget.style.transform = "translateY(-1px)";
                e.currentTarget.style.boxShadow = "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)";
              }
            }}
            onMouseOut={(e) => {
              if (!isDownloading) {
                e.currentTarget.style.borderColor = "#e2e8f0";
                e.currentTarget.style.color = "#1a1a1a";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 1px 2px rgba(0,0,0,0.05)";
              }
            }}
          >
            <FiDownload size={16} />
            {isDownloading ? "Generating..." : "Download Report"}
          </button> */}

          <div style={{ position: "relative" }} ref={dropdownRef}>
            <button
              className="user-profile-btn"
              onClick={() => setIsProfileOpen(!isProfileOpen)}
              style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center', justifyItems: 'center' }}
            >
              <span className="profile-name">{userName}</span>
              <span className="dropdown-icon" style={{ display: 'flex', alignItems: 'center' }}>
                <FaChevronDown />
              </span>
            </button>

            {isProfileOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "120%",
                  right: "0",
                  backgroundColor: "white",
                  borderRadius: "12px",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.15)",
                  padding: "12px",
                  minWidth: "220px",
                  zIndex: 100,
                }}
              >
                <div style={{ padding: "0 12px 10px 12px", marginBottom: "8px", borderBottom: userEmail ? "1px solid #f0f0f0" : "none" }}>
                  <p style={{ margin: 0, fontWeight: "700", color: "#1a1a1a", fontSize: "0.95rem" }}>{userName}</p>
                  {userEmail && (
                    <p style={{ margin: 0, color: "#8c8c8c", fontSize: "0.8rem", overflow: "hidden", textOverflow: "ellipsis" }}>{userEmail}</p>
                  )}
                </div>

                <button
                  onClick={() => {
                    setIsProfileOpen(false);
                    setShowChangePasswordModal(true);
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    width: "100%",
                    padding: "10px 12px",
                    border: "none",
                    background: "transparent",
                    color: "#1a1a1a",
                    fontWeight: "600",
                    cursor: "pointer",
                    borderRadius: "8px",
                    fontSize: "0.9rem",
                    transition: "background 0.2s",
                    marginBottom: "4px"
                  }}
                  onMouseOver={(e) =>
                    (e.target.style.backgroundColor = "#f5f5f5")
                  }
                  onMouseOut={(e) =>
                    (e.target.style.backgroundColor = "transparent")
                  }
                >
                  <FiLock /> Change Password
                </button>

                <button
                  onClick={handleLogoutClick}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    width: "100%",
                    padding: "10px 12px",
                    border: "none",
                    background: "transparent",
                    color: "#ef4444",
                    fontWeight: "600",
                    cursor: "pointer",
                    borderRadius: "8px",
                    fontSize: "0.9rem",
                    transition: "background 0.2s",
                  }}
                  onMouseOver={(e) =>
                    (e.target.style.backgroundColor = "#fef2f2")
                  }
                  onMouseOut={(e) =>
                    (e.target.style.backgroundColor = "transparent")
                  }
                >
                  <MdLogout /> Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Logout Confirmation Modal */}
      {showLogoutModal && (
        <div className="modal-overlay">
          <div
            className="modal-content"
            style={{
              maxWidth: "400px",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                backgroundColor: "#fef2f2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "1rem",
                color: "#ef4444",
                fontSize: "1.8rem",
              }}
            >
              <MdLogout />
            </div>
            <h3 className="modal-title" style={{ marginBottom: "10px" }}>
              Confirm Logout
            </h3>
            <p style={{ color: "#666", marginBottom: "20px" }}>
              Are you sure you want to log out of your account?
            </p>
            <div
              className="modal-actions"
              style={{
                justifyContent: "center",
                marginTop: "1rem",
                width: "100%",
              }}
            >
              <button
                onClick={() => setShowLogoutModal(false)}
                className="btn-secondary"
                style={{ width: "120px" }}
              >
                Cancel
              </button>
              <button
                onClick={confirmLogout}
                className="btn-primary"
                style={{
                  backgroundColor: "#ef4444",
                  width: "120px",
                  boxShadow: "0 4px 12px rgba(239, 68, 68, 0.2)",
                }}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Change Password Modal */}
      {showChangePasswordModal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ maxWidth: "450px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem" }}>
              <h2 className="modal-title" style={{ margin: 0 }}>Change Password</h2>
              <button
                onClick={resetChangePasswordForm}
                style={{ background: "transparent", border: "none", fontSize: "1.5rem", cursor: "pointer", color: "#888" }}
              >&times;</button>
            </div>

            <form onSubmit={handleChangePassword} style={{ display: "flex", flexDirection: "column", gap: "1.2rem" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <label style={{ fontSize: "0.9rem", fontWeight: "600", color: "#1a1a1a" }}>Old Password</label>
                <div style={{ position: 'relative' }}>
                  <FiLock style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#888' }} />
                  <input
                    type={showOldPassword ? "text" : "password"}
                    placeholder="Old password"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    required
                    style={{
                      width: "100%",
                      padding: "12px 40px 12px 40px",
                      borderRadius: "10px",
                      border: "1px solid #e2e8f0",
                      fontSize: "0.95rem",
                      boxSizing: 'border-box'
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowOldPassword(!showOldPassword)}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      color: '#888'
                    }}
                  >
                    {showOldPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <label style={{ fontSize: "0.9rem", fontWeight: "600", color: "#1a1a1a" }}>New Password</label>
                <div style={{ position: 'relative' }}>
                  <FiLock style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#888' }} />
                  <input
                    type={showNewPassword ? "text" : "password"}
                    placeholder="New password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                    style={{
                      width: "100%",
                      padding: "12px 40px 12px 40px",
                      borderRadius: "10px",
                      border: "1px solid #e2e8f0",
                      fontSize: "0.95rem",
                      boxSizing: 'border-box'
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      color: '#888'
                    }}
                  >
                    {showNewPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <label style={{ fontSize: "0.9rem", fontWeight: "600", color: "#1a1a1a" }}>Confirm Password</label>
                <div style={{ position: 'relative' }}>
                  <FiLock style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#888' }} />
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm new password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    style={{
                      width: "100%",
                      padding: "12px 40px 12px 40px",
                      borderRadius: "10px",
                      border: "1px solid #e2e8f0",
                      fontSize: "0.95rem",
                      boxSizing: 'border-box'
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      color: '#888'
                    }}
                  >
                    {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </div>

              <div className="modal-actions" style={{ marginTop: "1rem" }}>
                <button
                  type="button"
                  onClick={resetChangePasswordForm}
                  className="btn-secondary"
                  disabled={isChangingPassword}
                  style={{ flex: 1 }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-primary"
                  disabled={isChangingPassword}
                  style={{ flex: 1 }}
                >
                  {isChangingPassword ? "Updating..." : "Update Password"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
